<template >
  <b-container fluid>
    <app-header-register :data="header" />
    <app-body-register
      :data="dataComponents"
      v-if="dataComponents['itens'].length > 0"
      @submit="saveUserProfile($event)"
    >
      <template #bottom>
        <b-col cols="12" md="9" class="my-2">
          <label for="">Nova Senha</label>
          <b-input-group>
            <b-form-input
              :type="type ? 'password' : 'text'"
              v-model="newPwd"
              placeholder="**********"
              :state="newPwd == '' ? null : !$v.newPwd.$invalid"
            ></b-form-input>
            <b-input-group-append>
              <b-button class="btn-transparent" @click="type = !type"
                ><img :src="type ? require('@/assets/img/svgs/eye.svg') : require('@/assets/img/svgs/eye_off.svg')" alt=""
              /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </template>
      <template>
        <b-col cols="12" md="9" class="my-2">
          <small>
            <span
              class="badge  mx-1"
              :class="{'badge-success':$v.newPwd.upperCase, 'badge-danger':!$v.newPwd.upperCase && newPwd !== '', 'badge-secondary': newPwd === '' }"
              >1 letra maiuscula</span
            >
            <span
              class="badge mx-1"
              :class="{'badge-success':$v.newPwd.lowerCase, 'badge-danger':!$v.newPwd.lowerCase && newPwd !== '', 'badge-secondary': newPwd === '' }"
            
              >1 minuscula</span
            >
            <span
              class="badge mx-1"
              :class="{'badge-success':$v.newPwd.number, 'badge-danger':!$v.newPwd.number && newPwd !== '', 'badge-secondary': newPwd === '' }"

             
              >1 número</span
            >
            <span
              class="badge mx-1"
              :class="{'badge-success':$v.newPwd.special, 'badge-danger':!$v.newPwd.special && newPwd !== '', 'badge-secondary': newPwd === '' }"

            
              >1 caractere especial</span
            >
            <span
              class="badge mx-1"
              :class="{'badge-success':newPwd.length >= 12, 'badge-danger':newPwd.length < 12 && newPwd !== '', 'badge-secondary': newPwd === '' }"
              >mínimo de 12 caracteres</span
            >
            <span
              class="badge mx-1"
              :class="{'badge-success':$v.newPwdMatch.sameAsPassword, 'badge-danger':!$v.newPwdMatch.sameAsPassword && newPwdMatch !== '', 'badge-secondary': newPwdMatch === '' }"

            
              >senhas iguais</span
            >
          </small>
        </b-col>
        <b-col cols="12" md="9" class="my-2">
          <label for="">Confirmar Nova Senha</label>
          <b-input-group>
            <b-form-input
              :type="type_2 ? 'password' : 'text'"
              :state="newPwdMatch == '' ? null : !$v.newPwdMatch.$invalid"
              v-model="newPwdMatch"
              placeholder="**********"
            ></b-form-input>
            <b-input-group-append>
              <b-button class="btn-transparent" @click="type_2 = !type_2"
                ><img :src="type_2 ? require('@/assets/img/svgs/eye.svg') : require('@/assets/img/svgs/eye_off.svg')" alt=""
              /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </template>
    </app-body-register>
  </b-container>
  
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";
import { upperCase, lowerCase, number, special } from "@/utils/validators";
import api from "@/services/api";
import { mixins } from "@/mixins/mixins";
import utilsMixins from "@/mixins/utils";

export default {
  metaInfo: {
    title: "Perfil",
    titleTemplate: "%s | Odin",
  },
  mixins: [mixins, utilsMixins],
  beforeMount() {
    this.createComponents();
  },

  async mounted() {
    this.$store.commit("utils/setLoading", true);
    try {
      const { data } = await api.getUserProfileInfo();
      this.dataComponents.itens.forEach((el) => {
        if (el.key === "company") {
          el.model = data?.company?.name || "---";
        }
        if (el.key === "firstName") {
          el.model = data["firstName"];
        }
        if (el.key === "lastName") {
          el.model = data["lastName"];
        }
        if (el.key === "username") {
          el.model = data["username"];
        }
      });
    } catch (e) {
      this.errorCatch(e);
    } finally {
      this.$store.commit("utils/setLoading", false);
    }
  },
  data() {
    return {
      header: {
        title: "Meu Perfil",
        resume:
          "        Mantenha seus dados sempre atualizados preenchendo corretamente o formulário abaixo.",
        router: "/",
      },
      dataComponents: {
        itens: [],
        routeBack:'/',

      },
      newPwd: "",
      newPwdMatch: "",
      type: true,
      type_2: true,
    };
  },
  methods: {
    createComponents() {
      this.dataComponents["itens"] = [
        {
          key: "company",
          component: "b-form-input",
          label: "Empresa",
          visible: true,
          bind: {
            disabled: true,
          },
          model: "",
          required: true,
        },
        {
          key: "firstName",
          component: "b-form-input",
          label: "Nome",
          visible: true,
          model: "",
          required: true,
        },
        {
          key: "lastName",
          component: "b-form-input",
          label: "Sobrenome",
          visible: true,
          model: "",
          required: true,
        },
        {
          key: "username",
          component: "b-form-input",
          label: "E-mail",
          bind: {
            type: "email",
          },
          visible: true,
          model: "",
          required: true,
        },
      ];
    },

    async saveUserProfile({itens}) {
      let obj =  this.convertArrayToObject(itens)
      delete obj['company']
      if (this.newPwd !== "") {
        if (this.$v.$invalid) return;
        obj = {
          ...obj,
          newPwd: this.newPwd,
          newPwdMatch: this.newPwdMatch
        }
      }
      this.$store.commit("utils/setLoading", true);
    
      try {
        await api.updateInfos(obj);
        this.swalMessage({
          type: "success",
          title: "Sucesso",
          text: "Informações alteradas com sucesso!!",
        });
        this.$store.commit(
          "auth/setName",
          `${obj.firstName} ${obj.lastName}`
        );
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },
  },
  validations: {
    newPwd: {
      upperCase,
      lowerCase,
      number,
      special,
    },
    newPwdMatch: {
      sameAsPassword: sameAs("newPwd"),
    },
  },
};
</script>

<style scoped lang="scss">
.badge{
  font-family: Poppins;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 18px;
color: #fff;
}

button{
  border-radius:0px !important;
  border: 1px solid #EAECEC !important;
  background-color: #EAECEC;
  &:hover{
  background-color: #EAECEC !important

  }
}
</style>
